// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1KD-P","footer":"Form_footer__1mzQK"};